import { DelayedQuote } from '@benzinga/quotes-manager';

export const isCrypto = (quote?: DelayedQuote | null) => {
  return quote?.type === 'CRYPTO';
};

export const isETF = (quote: DelayedQuote) => {
  return quote?.type === 'ETF';
};

export const isStock = (quote: DelayedQuote) => {
  return quote?.type === 'STOCK';
};

export const cryptoTickers = [
  'BTC/USD',
  'ETH/USD',
  'ADA/USD',
  'DOGE/USD',
  'XRP/USD',
  'SOL/USD',
  'DOT/USD',
  'UNI/USD',
  'LTC/USD',
  'AVAX/USD',
  'LINK/USD',
  'GRT/USD',
  'XLM/USD',
  'MATIC/USD',
  'AXS/USD',
  'FIL/USD',
  'VET/USD',
  'ATOM/USD',
];
